import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { systemLogSeverityOptionSelectors } from '../state/system-logs-severity-select-option.reducer';
import { SystemLogSeverityOption } from '../system-logs-severity-option.interface';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: SystemLogSeveritySelectComponent,
        },
    ],
    selector: 'ndt-system-logs-severity-select',
    templateUrl: './system-logs-severity-select.component.html',
    standalone: false
})
export class SystemLogSeveritySelectComponent extends LcsSingleSelectBase<SystemLogSeverityOption> implements OnInit {
   systemLogSeverities$: Observable<SystemLogSeverityOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.systemLogSeverities$ = this.store.pipe(
         select(systemLogSeverityOptionSelectors.selectFilteredItems),
         map((items: Array<SystemLogSeverityOption>) => {
            let filteredItems = items;

            return filteredItems;
         })
      );
   }

   displayWith(item: SystemLogSeverityOption | null): string | null {
      return item ? item.name : null;
   }

   trackBy(item: SystemLogSeverityOption | null) {
      return item ? item.systemLogSeverityId : null;
   }
}
